import React from 'react';
import { Div, H3, RowDiv, Span, Text } from 'styles';

export function SubTitle({ title, sub, desc }) {
  return (
    <Div>
      <RowDiv $alignItems="flex-end" $gap={8}>
        <H3 $type="b38">{title}</H3>
        <Span $type="m20" $color="supportive">
          {sub}
        </Span>
      </RowDiv>
      <Text $paddingTop={8} $type="m20" $color="assistive">
        {desc}
      </Text>
    </Div>
  );
}
